/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  AnalyticChannelProvider component
 */

import type { AnalyticsC } from '@zcode/nr-utils'
import { createAllowedPropsAreEqual } from '@zcode/react-utils'
import React, { createContext, memo, useMemo } from 'react'

const areEqual = ['analyticChannel', 'children'] as const
const allowedProps = createAllowedPropsAreEqual<AnalyticChannelProviderProps>(areEqual)

export interface AnalyticChannelContextType {
  analyticChannel:
    | ''
    | typeof AnalyticsC.FULL_DETAIL
    | typeof AnalyticsC.HOMEPAGE
    | typeof AnalyticsC.LIST
    | typeof AnalyticsC.NEAR_ME
    | typeof AnalyticsC.LOCALE_GUIDE
}

export const AnalyticChannelContext = createContext<AnalyticChannelContextType>({
  analyticChannel: '',
})

export interface AnalyticChannelProviderProps extends AnalyticChannelContextType {
  children: React.ReactNode
}

export const AnalyticChannelProvider = memo(
  ({ analyticChannel, children }: AnalyticChannelProviderProps) => {
    const value = useMemo(() => {
      return { analyticChannel }
    }, [analyticChannel])
    return (
      <AnalyticChannelContext.Provider value={value}>{children}</AnalyticChannelContext.Provider>
    )
  },
  allowedProps
)
